import TableOfContentScreen from './TableOfContentScreen'

export default TableOfContentScreen
